/**
 * Pure identity and Firestore document-key utilities for the Rhythmé catalog.
 *
 * Public API is unchanged. Implementation lives in ids.cjs so the trusted
 * backend can apply the same generators without duplicating them.
 */

import impl from './ids.cjs';

export const CROCKFORD_ALPHABET = impl.CROCKFORD_ALPHABET;
export const ENTITY_PREFIXES = impl.ENTITY_PREFIXES;
export const EXTERNAL_NAMESPACES = impl.EXTERNAL_NAMESPACES;
export const generateCanonicalId = impl.generateCanonicalId;
export const isCanonicalEntityId = impl.isCanonicalEntityId;
export const generateReleaseTrackId = impl.generateReleaseTrackId;
export const providerAssetKey = impl.providerAssetKey;
export const normalizeExternalValue = impl.normalizeExternalValue;
export const externalIdKey = impl.externalIdKey;
export const userPlaylistId = impl.userPlaylistId;
export const generateNativePlaylistId = impl.generateNativePlaylistId;
export const userPlaylistItemId = impl.userPlaylistItemId;
export const createUserPlaylistItemIdentity = impl.createUserPlaylistItemIdentity;
export const recordingRelationId = impl.recordingRelationId;
